import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {DataService} from '../../../../../Services/data.service';
import { AppConfigService } from '../../../../../Services/app-config.service';
import { StorageService } from '../../../../../Services/storage.service';
import { Title } from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import { EmailService } from '../../../../../Services/email.service';
import { DateFilterService } from '../../../../../Services/dateFilter.service';
import { DataExportService } from '../../../../../Services/dataExport.service';
import {ResponseModel} from '../../../../../DataModels/response-model';
import {BsToastService} from '../../../../../Services/bs-toast-service';
import {EmailModel} from '../../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../../common/send-email-modal/send-email-modal.component';
import {Subject, takeUntil} from 'rxjs';
import {ReportPrintService} from '../../../../../Services/report-print.service';

export interface PayrollLineItem {
  line_item_id: string;
  category_type: string;
  pay_type_name: string | null;
  units: number | null;
  amount: number | null;
  employer_amount: number | null;
}

export interface PayrollCheck {
  payroll_run_id: string;
  gusto_payroll_uuid: string;
  check_date: string | null;
  pay_period_start: string | null;
  pay_period_end: string | null;
  processing_status: string;
  gross_pay: number | null;
  net_pay: number | null;
  line_items: PayrollLineItem[];
}

export interface PayrollEmployee {
  gusto_employee_uuid: string;
  employee_id: string | null;
  employee_name: string | null;
  check_count: number;
  checks: PayrollCheck[];
}

export interface PayrollRunGroup {
  check_date: string | null;
  pay_period_start: string | null;
  pay_period_end: string | null;
  processing_status: string;
  gross_pay: number | null;
  net_pay: number | null;
  earnings: PayrollLineItem[];
  taxes: PayrollLineItem[];
  benefits: PayrollLineItem[];
  deductions: PayrollLineItem[];
}

export interface PayrollEmployeeGroup {
  employee_name: string;
  runs: PayrollRunGroup[];
}

@Component({
  selector: 'app-employee-detail-report',
  templateUrl: './employee-detail-report.component.html',
  styleUrls: [],
  standalone: false,
})
export class EmployeeDetailReportComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('ExcelExport', { static: false }) ExcelExport: ElementRef;
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  rptName = '';
  timeOut = 0;
  isLoading = false;
  noDataFound = false;

  private unsubscribeDestroy$: Subject<void> = new Subject<void>();

  reportDataToSendInEmail: EmailModel = new EmailModel();

  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };

  vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/dd/yyyy',
    dateError: false,
    fromDateError: false,
    toDateError: false,
    showSpecificDates: false,
    buttonsDisabled: false,
    showFilters: false,
    report: [],
    request: {
      fromDate: null,
      toDate: null,
      employee_id: null,
      category_type: null,
    },
    employees: [],
    categoryTypes: [],
    Preferences: null,
    permissions: null,
    email: {
      toemail: null,
      fromemail: '',
      PdfHtml: null,
      Subject: null,
    },
  };

  groups: PayrollEmployeeGroup[] = [];
  totalRecords = 0;

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public aEmail: EmailService,
    public dateFilter: DateFilterService,
    public notification: BsToastService,
    private cd: ChangeDetectorRef,
    public excelExporter: DataExportService,
    public datePipe: DatePipe,
    private reportPrint: ReportPrintService
  ) {
    this.timeOut = this.appConfigService.toastrWarnTimeOut;
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences') || 'null');
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions') || 'null');
    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
    this.vm.email.fromemail = this.appConfigService.SysEmailAddress;
  }

  ngOnInit() {
    this.rptName = $localize`:Employee Pay Detail@@employeePayDetail:Employee Pay Detail`;
    this.newDateFilter(new Date(), new Date());
    const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
    this.vm.request.fromDate = range.fromDate;
    this.loadEmployeeList();
    this.loadCategoryTypes();
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.unsubscribeDestroy$.next();
    this.unsubscribeDestroy$.complete();
  }

  newDateFilter(toDate: any, fromDate: any) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
  }

  loadCategoryTypes(employeeId?: string) {
    const params: any = {};
    if (employeeId) {
      params.employeeId = employeeId;
    }
    this.tableDataService.getDataWithParams('PayrollReport/CategoryTypes', employeeId ? `employeeId=${employeeId}` : '')
      .pipe(takeUntil(this.unsubscribeDestroy$))
      .subscribe((result: any) => {
        this.vm.categoryTypes = result?.category_types || [];
      });
  }

  onEmployeeChange() {
    this.vm.request.category_type = null;
    this.loadCategoryTypes(this.vm.request.employee_id || undefined);
  }

  loadEmployeeList() {
    this.tableDataService
      .getDataWithParams('pr_employee', 'state=active&pageNumber=0&pageSize=999999')
      .pipe(takeUntil(this.unsubscribeDestroy$))
      .subscribe((result: any) => {
        this.vm.employees = result?.Data || result || [];
      });
  }

  update() {
    this.vm.fromDateError = this.vm.toDateError = this.vm.dateError = false;
    let errorDescription = '';

    if (!this.vm.request.fromDate) {
      this.vm.fromDateError = true;
      errorDescription += $localize`:From Date is required. @@fromDateisrequired:From Date is required.` + '\n';
    }
    if (!this.vm.request.toDate) {
      this.vm.toDateError = true;
      errorDescription += $localize`:To Date is required. @@toDateisrequired:To Date is required.` + '\n';
    }
    if (this.vm.request.fromDate && this.vm.request.toDate) {
      const from = new Date(this.vm.request.fromDate);
      const to = new Date(this.vm.request.toDate);
      if (to < from) {
        this.vm.dateError = true;
        errorDescription += $localize`:The To Date must be greater than the From Date. @@theToDatemustbegreaterthantheFromDate:The To Date must be greater than the From Date.` + '\n';
      }
    }

    if (errorDescription) {
      errorDescription.split('\n').forEach(msg => {
        if (msg) {
          this.notification.showWarningToast(msg);
        }
      });
      return;
    }

    const startDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
    const endDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);

    let params = `startDate=${startDate}&endDate=${endDate}&pageNumber=0&pageSize=9999`;
    if (this.vm.request.employee_id) {
      params += `&employeeId=${this.vm.request.employee_id}`;
    }
    if (this.vm.request.category_type) {
      params += `&categoryType=${this.vm.request.category_type}`;
    }

    this.isLoading = true;
    this.vm.buttonsDisabled = true;
    this.vm.report = [];
    this.groups = [];

    this.tableDataService.getDataWithParams('PayrollReport/PayrollDetail', params)
      .pipe(takeUntil(this.unsubscribeDestroy$))
      .subscribe({
        next: (result: any) => {
          const employees: PayrollEmployee[] = result?.employees || [];
          this.totalRecords = result?.totalEmployees ?? employees.length;
          this.vm.report = employees;
          this.groups = this.mapEmployees(employees);
          this.noDataFound = employees.length === 0;
          this.isLoading = false;
          this.vm.buttonsDisabled = false;
          this.vm.showFilters = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.vm.buttonsDisabled = false;
          this.notification.showErrorToast(err?.error?.message || $localize`:Error loading report@@errorLoadingReport:Error loading report`);
        },
      });
  }

  private mapEmployees(employees: PayrollEmployee[]): PayrollEmployeeGroup[] {
    return employees.map(emp => ({
      employee_name: emp.employee_name || emp.employee_id || 'Unknown',
      runs: emp.checks.map(check => {
        const earnings = check.line_items.filter(li => li.category_type === 'Hourly' || li.category_type === 'Fixed');
        const taxes = check.line_items.filter(li => li.category_type === 'Tax');
        const benefits = check.line_items.filter(li => li.category_type === 'Benefit');
        const deductions = check.line_items.filter(li => li.category_type === 'Deduction');
        return {
          check_date: check.check_date,
          pay_period_start: check.pay_period_start,
          pay_period_end: check.pay_period_end,
          processing_status: check.processing_status,
          gross_pay: check.gross_pay,
          net_pay: check.net_pay,
          earnings,
          taxes,
          benefits,
          deductions,
        };
      }),
    }));
  }

  clear() {
    this.vm.request.employee_id = null;
    this.vm.request.category_type = null;
    this.vm.report = [];
    this.groups = [];
    this.noDataFound = false;
    this.loadCategoryTypes();
  }

  close() {
    this.router.navigate(['/home']);
  }

  exportToExcel() {
    const currentDate = new Date().toDateString();
    this.excelExporter.exportToExcel(this.ExcelExport, 'PayrollDetail_' + currentDate + '.xlsx');
  }

  setEmailData() {
    this.getReportData();
    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  getReportData() {
    const emailDocObj = {} as EmailModel;
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = this.vm.email?.toemail || '';
    emailDocObj.body = 'Please see the attached ' + this.rptName + '.<br><br>Best regards,<br><br>AcctXErp<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + this.rptName;
    try {
      this.cd.detectChanges();
    } catch {
    }
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = this.ExcelExport?.nativeElement?.outerHTML || '';
    }
    emailDocObj.activity_message = this.rptName;
    const now = new Date();
    emailDocObj.FileName = `Payroll_Detail_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}.pdf`;
    this.reportDataToSendInEmail = emailDocObj;
  }

  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Payroll Detail print failed', e);
    }
  }

  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Employee Detail Report', contentHtml: content, meta, orientation: 'landscape'});
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(text: string): string {
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  sumAmount(rows: PayrollLineItem[]): number {
    return rows.reduce((acc, r) => acc + (r.amount ?? 0), 0);
  }

  sumEmployerAmount(rows: PayrollLineItem[]): number {
    return rows.reduce((acc, r) => acc + (r.employer_amount ?? 0), 0);
  }

  sumUnits(rows: PayrollLineItem[]): number {
    return rows.reduce((acc, r) => acc + (r.units ?? 0), 0);
  }

  formatCurrency(val: number | null): string {
    if (val == null) {
      return '';
    }
    return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(val);
  }

  formatDate(val: string | null): string {
    if (!val) {
      return '';
    }
    const d = new Date(val);
    return isNaN(d.getTime()) ? val : this.datePipe.transform(d, 'MM/dd/yyyy') || val;
  }
}
